import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

export const onRouteUpdate = () => {
    if (typeof document !== "undefined") {
        const elements = document.querySelectorAll(".fadeInUp")

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("on")
                    }
                })
            },
            { threshold: 0.1 }
        )

        elements.forEach((el) => {
            observer.observe(el)

            // ページロード時にすでに見えていたら即クラス付与
            const rect = el.getBoundingClientRect()
            if (rect.top < window.innerHeight && rect.bottom > 0) {
                el.classList.add("on")
            }
        })

        return () => {
            elements.forEach((el) => observer.unobserve(el))
        }
    }
}
